import React from 'react'
import CategoryItem from './CategoryItem'
import styles from './CategorySelector.module.css'

const CategoryList = ({ categories, isExpanded, selectedCategory, onSelectCategory }) => {
    return (
        <div className={isExpanded ? styles.gridContainer : styles.scrollContainer}>
            {categories.map((category, index) => (
                <CategoryItem
                    key={index}
                    label={category}
                    isSelected={category === selectedCategory}
                    onClick={() => onSelectCategory(category)}
                />
            ))}
        </div>
    )
}

export default CategoryList
